import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Calendar, Mail, Clock } from "lucide-react";
import "./ThankYou.css";

const formatDemoDateTime = (date) => {
  if (!date || !(date instanceof Date)) return "—";
  const dateStr = date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return `${dateStr} at 10:00 AM`;
};

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { date: demoDate, email: demoEmail } = location.state || {};
  const dateTimeStr = formatDemoDateTime(demoDate);
  const emailDisplay = demoEmail || "—";

  return (
    <>
      <Helmet>
        <title>Demo Confirmed | TeamGrid</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="thank-you-outer">
      <section className="thank-you-section">
        {/* Header: icon + title + subtitle */}
        <div className="thank-you-head-block">
          <div className="thank-you-overlay">
            <img src="/thanks_tick.webp" alt="Success" className="thank-you-tick-img" />
          </div>
          <h1 className="thank-you-heading">You're All Set!</h1>
          <p className="thank-you-subtitle">
            Your demo has been confirmed. We've sent you a calendar invite with all the details.
          </p>
        </div>

        {/* Confirmation Details card */}
        <div className="thank-you-details-card">
          <h3 className="thank-you-details-title">Confirmation Details</h3>
          <div className="thank-you-details-list">
            <div className="thank-you-details-row">
              <div className="thank-you-details-icon-wrap">
                <Calendar className="thank-you-details-icon" size={20} stroke="#00D1C1" />
              </div>
              <div className="thank-you-details-text">
                <span className="thank-you-details-label">Date & Time</span>
                <span className="thank-you-details-value">{dateTimeStr}</span>
              </div>
            </div>
            <div className="thank-you-details-row">
              <div className="thank-you-details-icon-wrap">
                <Mail className="thank-you-details-icon" size={20} stroke="#00D1C1" />
              </div>
              <div className="thank-you-details-text">
                <span className="thank-you-details-label">Sent to</span>
                <span className="thank-you-details-value">{emailDisplay}</span>
              </div>
            </div>
            <div className="thank-you-details-row">
              <div className="thank-you-details-icon-wrap">
                <Clock className="thank-you-details-icon" size={20} stroke="#00D1C1" />
              </div>
              <div className="thank-you-details-text">
                <span className="thank-you-details-label">Duration</span>
                <span className="thank-you-details-value">30 minutes</span>
              </div>
            </div>
          </div>
        </div>

        {/* What happens next */}
        <div className="thank-you-next-block">
          <h3 className="thank-you-next-title">What happens next?</h3>
          <div className="thank-you-next-steps">
            <div className="thank-you-step-card">
              <div className="thank-you-step-num">1</div>
              <div className="thank-you-step-content">
                <span className="thank-you-step-heading">Check your email</span>
                <span className="thank-you-step-desc">We've sent a calendar invite with the meeting link</span>
              </div>
            </div>
            <div className="thank-you-step-card">
              <div className="thank-you-step-num">2</div>
              <div className="thank-you-step-content">
                <span className="thank-you-step-heading">Prepare your questions</span>
                <span className="thank-you-step-desc">Think about your specific use cases and team needs</span>
              </div>
            </div>
            <div className="thank-you-step-card">
              <div className="thank-you-step-num">3</div>
              <div className="thank-you-step-content">
                <span className="thank-you-step-heading">Join the call</span>
                <span className="thank-you-step-desc">We'll send you a reminder 15 minutes before</span>
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="thank-you-buttons">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="thank-you-btn-primary"
          >
            Back to Home
          </button>
          <button
            type="button"
            onClick={() => navigate("/book-demo")}
            className="thank-you-btn-secondary"
          >
            Book Another Demo
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="thank-you-footer" style={{ borderTopColor: "rgba(0, 0, 0, 0.2)" }}>
        <div className="thank-you-footer-inner">
          <span className="thank-you-footer-text">Need to reschedule? Email us at</span>
          <a href="mailto:hello@teamgrid.ai" className="thank-you-footer-link">
            hello@teamgrid.ai
          </a>
        </div>
      </footer>
    </div>
    </>
  );
};

export default ThankYou;
